import { ColumnCta } from '@ahc-digital/component-library';
import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { CreateMultiColumnCTAModel } from './C05MulticolumnCTAs.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C05MulticolumnCTAProps = RenderingProps<C05MulticolumnCTAFields, RenderingParams>;

export type C05MulticolumnCTAFields = {
  Headline?: Field<string>;
  BodyCopy?: RichTextField;
  ExtraCTA?: LinkField;
};

export type RenderingParams = {
  TitleType?: string;
  TitleAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export const Default = (props?: C05MulticolumnCTAProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <ColumnCta
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateMultiColumnCTAModel(props)}
    />
  );
};
